import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import ToastNotification from '../ToastNotification/ToastNotification';

const RegisterPassword5 = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [userId, setUserId] = useState(null);
    const [userName, setUserName] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Estado para o Toast
    const [toast, setToast] = useState({ show: false, message: '', type: '' });

    const showMessage = (msg, type) => {
        setToast({ show: true, message: msg, type: type });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 5000);
    };

    // Recupera dados do Token (ID e UserName/Subject)
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserId(decoded.id || decoded.userId || decoded.sub);
                setUserName(decoded.sub || ''); // Geralmente o userName está no 'sub'
            } catch (error) {
                console.error("Erro ao decodificar token:", error);
                showMessage("Sessão inválida. Reinicie o processo.", "error");
            }
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validação de coincidência de senha
        if (password !== confirmPassword) {
            showMessage("As senhas não coincidem!", "error");
            return;
        }

        // Validação de força mínima (exemplo: 8 caracteres)
        if (password.length < 8) {
            showMessage("A senha deve ter no mínimo 8 caracteres.", "error");
            return;
        }

        setLoading(true);
        const token = localStorage.getItem('token');

        try {
            const response = await axios.post(
                `https://phantomtech.com.br/AutomaTech/api/credentials/setPassword`,
                {
                    userId: userId,
                    password: password
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            if (response.status === 200) {
                showMessage(response.data.message || "Senha cadastrada com sucesso! Redirecionando para o Login...", "success");
                // Limpa o token temporário após o cadastro bem sucedido
                setTimeout(() => {
                    localStorage.removeItem('token');
                    window.location.href = '/login'; // Ou o caminho do seu login
                }, 8000);
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'Erro ao definir a nova senha.';
            showMessage(errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container vh-100 d-flex justify-content-center align-items-center">
            <ToastNotification
                show={toast.show}
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ ...toast, show: false })}
            />

            <div className="col-12 col-md-8 col-lg-5">
                <div className="card shadow-sm border-primary">
                    <div className="card-body p-4">
                        
                        <h3 className="card-title text-center mb-1">Cadastramento de Senha - Passo 5</h3>
                        <p className="text-center text-muted mb-4">Último passo: digite e repita sua senha de acesso, mínimo de 8 caracteres, podendo ser letras, numeros e caracteres especiais como #$%@* </p>

                        <form onSubmit={handleSubmit}>
                            {/* Campo Senha */}
                            <div className="mb-3">
                                <label className="form-label fw-bold small text-secondary">Registre sua Senha</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control form-control-lg"
                                        placeholder="Digite sua senha"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                    <button 
                                        className="btn btn-outline-secondary" 
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        <i className={`bi bi-eye${showPassword ? '-slash' : ''}`}></i>
                                    </button>
                                </div>
                            </div>

                            {/* Campo Repetir Senha */}
                            <div className="mb-4">
                                <label className="form-label fw-bold small text-secondary">Repita a mesma Senha</label>
                                <input
                                    type="password"
                                    className="form-control form-control-lg"
                                    placeholder="Confirme sua senha"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                {confirmPassword && password !== confirmPassword && (
                                    <small className="text-danger">As senhas são diferentes.</small>
                                )}
                            </div>

                            <div className="d-grid mt-4">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary btn-lg fw-bold shadow-sm"
                                    disabled={loading || !password || password !== confirmPassword}
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Salvando...
                                        </>
                                    ) : 'ENVIAR'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="text-center mt-3">
                    <small className="text-muted">
                        <i className="bi bi-shield-lock-fill me-1"></i>
                        Use uma senha forte com letras, números e símbolos.
                    </small>
                </div>
            </div>
        </div>
    );
};

export default RegisterPassword5;